import confirmSignageModalTemplate from './confirm-signage.modal.html';
import bannerNotificationTemplate from './banner-acceptance.modal.html';
import { template } from 'underscore';

(function () {
    angular.module("cardspotWeb.areas.enterSales")
        .controller("EnterSales", EnterSales);

    EnterSales.$inject = ["$scope", "$timeout", "$location", "cardFees", "appConfig", "preActivationService", "sundryService", "NAV_URLS", 
        "EVENT_NAMES", "$uibModal", "authService", "$rootScope", "SF_EVENTS", "BANNER_NOTIFICATION"];

    function EnterSales($scope, $timeout, $location, cardFees, appConfig, preActivationService, sundryService, NAV_URLS, 
        EVENT_NAMES, $uibModal, authService, $rootScope, SF_EVENTS, BANNER_NOTIFICATION) {
        var model = this;

        var SALES_TYPES = {
			INDIVIDUAL: "consumer",
			COMPANY: "corporate"
		};
        $scope.SALES_TYPES = SALES_TYPES;
        model.confirmSignageDialog = confirmSignage;
        model.salesType = SALES_TYPES.INDIVIDUAL;
        
        $rootScope.$on(SF_EVENTS.LOGGED_IN_SUCCESS, showBannerNotification());

        init();

        function init() {
            model.salesType = $location.path().split('/').pop();
        }

        function confirmSignage() {
            appConfig.getDisplayFeeBasedSignageMessageFlag(appConfig.selectedMerchantGroup().uniqueTag).then(function (response) {
                var displayFeeBasedSignageMessage = response.data;
                if (!authService.signageConfirmed() && displayFeeBasedSignageMessage && !isSundryPath()) {
                    var modalInstance = $uibModal.open({
                        template: confirmSignageModalTemplate,
                        controller: "SignageConfirm",
                        controllerAs: "model",
                        backdrop: "static",
                        keyboard: false,
                        size: "sm"
                    });
                }
            });
        }

        function showBannerNotification() {
            // The app is being retired, so we no longer check prior acceptance.
            // Display the banner on every login while today is within the notification window.
            if (isTodayBetweenBannerNotificationDates()) {
                $uibModal.open({
                    template: bannerNotificationTemplate,
                    controller: "BannerAcceptance",
                    controllerAs: "model",
                    backdrop: "static",
                    keyboard: false,
                    size: "md"
                });
            }
        }

        function isTodayBetweenBannerNotificationDates() {
            let startDate = new Date(BANNER_NOTIFICATION.START_DATE);
            let endDate = new Date(BANNER_NOTIFICATION.END_DATE);
            let today = new Date();

            today.setHours(0,0,0,0);

            return today.getTime() >= startDate.getTime() &&
                   today.getTime() <= endDate.getTime();
        }

        function cardActivationsComplete() {
            cardFees.getFees(
                appConfig.selectedMerchantGroup().uniqueTag,
                preActivationService.getProgramUniqueTag(),
                preActivationService.getCardsPreActivated()
                )
                .then(function () {
                    $timeout(function () {
                        $scope.$broadcast(EVENT_NAMES.SHOWING_SALE_SUMMARY, {});
                        $scope.$broadcast(EVENT_NAMES.ON_CARD_PREACTIVATED_WITH_CODE);
                        model.changeActiveView(model.VIEW_NAMES.SUMMARY);
                    });
            });
        }

         function sundrySalesComplete() {
            $timeout(function () {
                $scope.$broadcast(EVENT_NAMES.SHOWING_SALE_SUMMARY, {});
                model.changeActiveView(model.VIEW_NAMES.SUMMARY);
            });
        }

         $scope.salesComplete = function () {
            if(preActivationService.hasCards()){
                cardActivationsComplete();
            } else {
                sundrySalesComplete();
            }
        };

        $scope.saleCompleted = function () {
            $scope.$broadcast(EVENT_NAMES.SHOWING_SALE_COMPLETE, {});
            model.changeActiveView(VIEW_NAMES.SALE_COMPLETE);
        };

        $scope.editCards = function() {
            showCardActivations();
        };

         $scope.editSundries = function() {
            showSundrySales();
        };

        $scope.startOver = function() {
            isSundryPath() ? showSundrySales() : showCardActivations();
        };

        function showCardActivations() {
            $scope.$broadcast("showing-card-activations", {});
            model.changeActiveView(VIEW_NAMES.CARD_ACTIVATIONS);
        }

         function showSundrySales() {
            $scope.$broadcast("showing-sundry-sales", {});
            model.changeActiveView(VIEW_NAMES.SUNDRY_SALES);
        }

        var VIEW_NAMES = {
            CARD_ACTIVATIONS: "card-activations",
            SUMMARY: "summary",
            SALE_COMPLETE: "sale-complete",
            SUNDRY_SALES: "sundry-sales"
        };
        model.VIEW_NAMES = VIEW_NAMES;
        var activeView = isSundryPath() && !sundryService.hasSundries() ? VIEW_NAMES.SUNDRY_SALES : VIEW_NAMES.CARD_ACTIVATIONS;

        model.viewVisible = function (viewName) {
            return viewName === activeView;
        };

        model.changeActiveView = function (view) {
            activeView = view;
        };

        function isSundryPath(){
            return $location.path() === NAV_URLS.ENTER_SUNDRIES;
        }

        $scope.isSundryPath = function(){
            return isSundryPath();
        };
    }
}());